'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _rcTable = require('rc-table');

var _rcTable2 = _interopRequireDefault(_rcTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ColumnGroup = function (_RcTable$ColumnGroup) {
  (0, _inherits3["default"])(ColumnGroup, _RcTable$ColumnGroup);

  function ColumnGroup() {
    (0, _classCallCheck3["default"])(this, ColumnGroup);
    return (0, _possibleConstructorReturn3["default"])(this, _RcTable$ColumnGroup.apply(this, arguments));
  }

  return ColumnGroup;
}(_rcTable2["default"].ColumnGroup);

exports["default"] = ColumnGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/table/ColumnGroup.js
// module id = 330
// module chunks = 0